import { mount } from 'svelte';
import './app.css';
import Router from './Router.svelte';
import { initializeI18n, detectBrowserLocale } from './lib/i18n';
import { LOCALE_CACHE_KEY } from './lib/stores/settingsStore';

/**
 * Initialize the application
 * 1. Read cached locale from localStorage (instant, survives page reload)
 * 2. Fall back to browser detection if no cache exists
 * 3. Initialize i18n and mount the Router
 */
async function bootstrap() {
  // Use cached locale (set by settingsStore on successful load) or fall back to browser detection
  const initialLocale = localStorage.getItem(LOCALE_CACHE_KEY) || detectBrowserLocale();

  // Initialize i18n before rendering
  await initializeI18n(initialLocale);

  // Mount the app
  const app = mount(Router, {
    target: document.getElementById('app')!,
  });

  return app;
}

bootstrap().catch((error) => {
  console.error('Failed to bootstrap application:', error);
  // Fallback: still mount the app even if i18n init fails
  mount(Router, {
    target: document.getElementById('app')!,
  });
});
